import React from "react"

function Footer() {
    return (
        <footer>Saltines © 2019</footer>
    )
}

export default Footer;